import { z } from 'zod';

export const MyProfileFormSchema = z.object({
  id: z.string().min(1).optional(),
  first_name: z.string().min(1, {
    message: "First Name can't be empty",
  }),
  last_name: z.string().min(1, {
    message: "Last Name can't be empty",
  }),
  consultant_firm_affiliated: z.array(z.string()).min(1, {
    message: "Consultant Firm Affiliated can't be empty",
  }),
  phone: z.string().min(1, {
    message: "Phone can't be empty",
  }),
  email: z.string().email({ message: 'Invalid Email Address' }),
  // Optional fields
  photo_url: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  zip_code: z.string().nullish(),
  address: z.string().nullish(),
  meeting_link: z.string().nullish(),
  linkedin: z.string().nullish(),
  website: z.string().nullish(),
  preferred_markets: z
    .array(z.string())
    .max(20, {
      message: 'You can select up to 20 markets',
    })
    .optional(),
});
